/**
 * @fileoverview Portuguese translations.
 * @package PlayItNow
 * @module apps/front/lib/i18n/locales/pt
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

export const pt = {
  login: {
    title: 'PlayItNow',
    subtitle: 'Inicie sessão no seu espaço de administração',
    emailLabel: 'Email ou nome de utilizador',
    emailPlaceholder: 'seu@email.com ou nome de utilizador',
    passwordLabel: 'Palavra-passe',
    passwordPlaceholder: '••••••••',
    submitButton: 'Iniciar sessão',
    submitting: 'A iniciar sessão...',
    forgotPassword: 'Esqueceu a palavra-passe?',
    noAdminRights: 'Não tem direitos de administração',
    errorGeneric: 'Ocorreu um erro durante o início de sessão',
    showPassword: 'Mostrar palavra-passe',
    hidePassword: 'Ocultar palavra-passe',
  },
  auth: {
    optional: 'opcional',
  },
  home: {
    title: 'Vote nas suas músicas favoritas em concertos ao vivo!',
    wantToVote: 'Quero votar',
    wantToVoteDescription: 'Crie uma conta gratuita para votar nos concertos',
    wantToManageBand: 'Gero o meu grupo',
    wantToManageBandDescription: 'Crie uma conta para gerir os seus eventos e músicas',
    alreadyHaveAccount: 'Já tem uma conta?',
  },
  landing: {
    languageLabel: 'Escolha o seu idioma',
    heroTitle: 'Deixe o público escolher a próxima música da sua setlist',
    heroSubtitle:
      'Monte a sua setlist. Os fãs escaneiam um código QR e votam na próxima música em tempo real. Uma experiência única em cada concerto.',
    ctaPrimary: 'Criar minha conta de grupo — teste grátis',
    whyTitle: 'Porquê PlayItNow?',
    benefit1Title: 'Um QR, o público vota',
    benefit1Desc: 'O seu público escaneia e vota nas músicas favoritas pelo telemóvel. Mais interatividade.',
    benefit2Title: 'Ranking em direto',
    benefit2Desc: 'Os votos aparecem em tempo real. Toque os temas mais pedidos no palco.',
    benefit3Title: 'Simples para bandas',
    benefit3Desc: 'Crie eventos, gere o seu setlist, lance a votação num clique. Preços para artistas.',
    twoWaysTitle: 'Duas formas de viver o PlayItNow',
    ctaBand: 'Sou uma banda',
    ctaBandDesc: 'Crie eventos, adicione as suas músicas, deixe o público votar em direto.',
    ctaFan: 'Sou espetador',
    ctaFanDesc: 'Junte-se a um concerto pelo código QR e vote nas músicas que quer ouvir.',
    alreadyAccount: 'Já tem conta?',
    login: 'Entrar',
    learnMore: 'Ver eventos',
  },
  public: {
    login: {
      title: 'PlayItNow',
      subtitle: 'Vote nas suas músicas favoritas!',
      subtitle2: 'As faixas vencedoras serão tocadas ao vivo!',
      identifyTitle: 'Identifique-se',
      identifySubtitle: 'Vote para escolher a próxima música do concerto!',
      emailLabel: 'Email ou nome de utilizador',
      emailPlaceholder: 'seu@email.com ou nome de utilizador',
      passwordLabel: 'Palavra-passe',
      passwordPlaceholder: '••••••••',
      submitButton: 'Iniciar sessão',
      submitting: 'A iniciar sessão...',
      loading: 'A carregar...',
      withoutRegistration: 'Aceder à votação',
      or: 'OU',
      errorGeneric: 'Ocorreu um erro',
      showPassword: 'Mostrar palavra-passe',
      hidePassword: 'Ocultar palavra-passe',
      firstNameLabel: 'O seu primeiro nome (opcional)',
      firstNamePlaceholder: 'João',
      firstNameHint: 'O seu nome será mostrado quando votar',
      haveAccount: 'Tenho uma conta',
      forgotPassword: 'Esqueceu a palavra-passe?',
      createAccount: 'Criar uma conta',
      pinDataHub: 'Gerir o meu grupo',
      orDivider: 'ou',
      loginWithGoogle: 'Entrar com Google',
      loginWithFacebook: 'Entrar com Facebook',
      oauthNoAccount: 'Nenhuma conta associada a este perfil. Escolha « Conta fã » ou « Conta grupo » na página inicial e continue com Google ou Facebook.',
      oauthFailed: 'Falha ao entrar com este fornecedor. Tente novamente.',
      oauthNoEmail: 'O Facebook não forneceu um email. Verifique as permissões ou registe-se com o Google.',
      oauthUnavailable: 'Entrada com este fornecedor temporariamente indisponível.',
      oauthUseProvider: 'Entrar com Google ou Facebook.',
      oauthCompleteEmailTitle: 'O Facebook não partilhou o seu email',
      oauthCompleteEmailDescription: 'Introduza o seu email para concluir a ligação.',
      oauthCompleteEmailSubmit: 'Concluir ligação',
      oauthCompleteEmailPlaceholder: 'seu@email.com',
      oauthCompleteEmailExpired: 'Sessão expirada. Tente novamente com o Facebook.',
      oauthCompleteEmailNoAccount: 'Escolha primeiro um tipo de conta (fã ou grupo) na página inicial.',
    },
    register: {
      title: 'Criar uma conta',
      subtitle: 'Junte-se à comunidade PlayItNow',
      firstNameLabel: 'Primeiro nome',
      firstNamePlaceholder: 'João',
      lastNameLabel: 'Apelido',
      lastNamePlaceholder: 'Silva',
      emailLabel: 'Email',
      emailPlaceholder: 'seu@email.com',
      usernameLabel: 'Nome de utilizador',
      usernamePlaceholder: 'joao.silva',
      autoGenerated: 'Gerado automaticamente',
      usernameHint: 'Pode modificar este nome de utilizador',
      submitButton: 'Criar a minha conta',
      submitting: 'A criar conta...',
      backToLogin: 'Voltar ao início de sessão',
      orDivider: 'ou',
      continueWithGoogle: 'Continuar com Google',
      continueWithFacebook: 'Continuar com Facebook',
      successTitle: 'Registo realizado com sucesso!',
      successMessage:
        'Foi enviado um email de confirmação. Verifique a sua caixa de entrada para ativar a sua conta.',
      error: {
        firstNameRequired: 'O primeiro nome é obrigatório',
        lastNameRequired: 'O apelido é obrigatório',
        emailRequired: 'O email é obrigatório',
        generic: 'Ocorreu um erro ao criar a conta',
      },
      bandNameLabel: 'Nome do grupo',
      bandNamePlaceholder: 'Nome do seu grupo',
      passwordLabel: 'Palavra-passe',
      passwordPlaceholder: '••••••••',
      passwordMinLength: 'A palavra-passe deve ter pelo menos 8 caracteres',
      logoUrlLabel: 'URL do logótipo (opcional)',
      logoUrlPlaceholder: 'https://example.com/logo.png',
      showPassword: 'Mostrar palavra-passe',
      hidePassword: 'Ocultar palavra-passe',
    },
    events: {
      title: 'Próximos eventos',
      noEvents: 'Sem eventos agendados',
      noEventsDescription: 'Não há eventos previstos nos próximos 2 dias.',
      errorLoad: 'Erro ao carregar os eventos',
      settings: 'Definições',
      logout: 'Terminar sessão',
    },
    event: {
      invalidSlug: 'Slug de evento inválido',
      notFound: 'Evento não encontrado',
      errorLoad: 'Erro ao carregar o evento',
      backToEvents: 'Voltar aos eventos',
      songsTitle: 'Músicas disponíveis',
      noSongs: 'Nenhuma música disponível no momento',
      vote: 'Votar',
      voted: 'Votado',
      loading: 'A carregar...',
      votesRemaining: 'Votos restantes',
      voteSuccess: 'O seu voto foi registado!',
      voteError: 'Erro ao registar o seu voto',
      totalVotes: 'Total de votos',
      votesLabel: 'votos',
      blindVoteMessage: 'O ranking será revelado pelo grupo.',
      rankingTitle: 'Ranking',
      votingPaused: 'A votação está temporariamente suspensa.',
      votingCompleted: 'Este evento terminou. A votação está fechada.',
      settings: 'Definições',
      logout: 'Terminar sessão',
    },
    qrCode: {
      title: 'Partilhar este evento',
      description: 'Digitalize este código QR ou partilhe a ligação para convidar outros a votar',
      share: 'Partilhar',
      copy: 'Copiar ligação',
      show: 'Mostrar código QR',
      shareText: 'Junte-se a mim para votar nas músicas de {{eventName}}!',
    },
    settings: {
      title: 'Definições da conta',
      account: 'Conta',
      email: 'Email',
      username: 'Nome de utilizador',
      firstName: 'Primeiro nome',
      lastName: 'Apelido',
      save: 'Guardar',
      saving: 'A guardar...',
      success: 'Definições guardadas com sucesso',
      error: 'Erro ao guardar as definições',
      password: {
        title: 'Alterar palavra-passe',
        currentPassword: 'Palavra-passe atual',
        currentPasswordPlaceholder: '••••••••',
        newPassword: 'Nova palavra-passe',
        newPasswordPlaceholder: '••••••••',
        confirmPassword: 'Confirmar nova palavra-passe',
        confirmPasswordPlaceholder: '••••••••',
        change: 'Alterar palavra-passe',
        changing: 'A alterar...',
        success: 'Palavra-passe alterada com sucesso. Por favor, inicie sessão novamente.',
        error: 'Erro ao alterar a palavra-passe',
        mismatch: 'As palavras-passe não coincidem',
        incorrect: 'A palavra-passe atual está incorreta',
      },
      deleteAccount: {
        title: 'Eliminar conta',
        description: 'A eliminação da sua conta é irreversível e definitiva.',
        button: 'Eliminar a minha conta',
        confirming: 'A confirmar...',
        confirmTitle: 'Confirmar eliminação',
        confirmMessage: 'Tem a certeza que deseja eliminar a sua conta? Esta ação é irreversível.',
        confirmButton: 'Sim, eliminar',
        cancelButton: 'Cancelar',
        success: 'Conta eliminada com sucesso',
        error: 'Erro ao eliminar a conta',
      },
    },
    dataExport: {
      title: 'Exportar os seus dados',
      description:
        'Em conformidade com o RGPD, pode solicitar a exportação de todos os seus dados pessoais armazenados no PlayItNow.',
      whatIncluded: 'A exportação incluirá:',
      included: {
        profile: 'As suas informações de perfil (email, nome, primeiro nome, etc.)',
        votes: 'O seu histórico de votos',
        preferences: 'As suas preferências (tema, idioma)',
        sessions: 'As suas sessões de início de sessão',
      },
      exportButton: 'Exportar os meus dados',
      exporting: 'A exportar...',
      success: 'Os seus dados foram exportados com sucesso. O download vai começar.',
      error: 'Ocorreu um erro ao exportar os seus dados.',
      note: 'Nota: A exportação dos seus dados pode demorar alguns instantes. O ficheiro estará em formato JSON.',
    },
  },
  legal: {
    title: 'Nota legal',
    editor: {
      title: 'Editor',
      name: 'axialdata',
      email: 'Email: contact@axialdata.net',
      siret: 'SIRET: 49347625300023',
    },
    publication: {
      title: 'Diretor da publicação',
      director: 'Pierre-Yves Léglise',
    },
    hosting: {
      title: 'Alojamento',
      name: 'Hostinger International Ltd',
      addressLine1: 'A aplicação está alojada em França (centro de dados de Paris).',
      addressLine2: 'Sede social: Švitrigailos g. 34, LT-03230 Vilnius, Lituânia',
      country: 'Lituânia',
      url: 'https://www.hostinger.com',
    },
    dataProtection: {
      title: 'Proteção de dados',
      description:
        'Em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD), tem direitos sobre os seus dados pessoais.',
      link: 'Consulte a nossa política de privacidade',
    },
  },
  privacy: {
    title: 'Política de privacidade',
    lastUpdated: 'Última atualização: outubro de 2025',
    intro: {
      title: 'Introdução',
      description:
        'O PlayItNow compromete-se a proteger a sua privacidade e dados pessoais. Esta política explica como recolhemos, utilizamos e protegemos a sua informação.',
    },
    dataCollection: {
      title: 'Dados recolhidos',
      bands: {
        title: 'Para os grupos (clientes pagantes)',
        email: 'Morada de email',
        username: 'Nome de utilizador',
        name: 'Nome do grupo e informações de contacto',
        payment: 'Informações de pagamento (via prestador terceiro seguro)',
        logo: 'Logótipo do grupo',
      },
      spectators: {
        title: 'Para os espetadores (utilizadores gratuitos)',
        email: 'Morada de email (se criar conta)',
        firstName: 'Primeiro nome (opcional, para exibição durante os votos)',
        fingerprint: 'Impressão digital do navegador (anti-fraude)',
        ip: 'Morada IP (para segurança e auditoria)',
        votes: 'Histórico dos votos efetuados',
      },
    },
    purposes: {
      title: 'Finalidades do tratamento',
      authentication: 'Autenticação e gestão de contas de utilizador',
      voting: 'Gestão do sistema de vote interativo',
      fraud: 'Prevenção da fraude e segurança dos votos',
      billing: 'Faturação e gestão de assinaturas (apenas grupos)',
      support: 'Suporte ao cliente e assistência técnica',
      preferences: 'Memorização das preferências (tema, idioma)',
      analytics: 'Medição de audiência do site (Rybbit autoalojado, uso interno: páginas vistas, proveniência; nenhum dado vendido nem cedido)',
    },
    legalBasis: {
      title: 'Base legal',
      description:
        'O tratamento dos seus dados baseia-se em: (1) execução de contrato para os grupos, (2) o seu consentimento para os espetadores, (3) o nosso interesse legítimo na segurança e prevenção da fraude.',
    },
    retention: {
      title: 'Prazo de conservação',
      active: 'Dados de conta ativa: conservados durante toda a utilização do serviço',
      inactive: 'Dados de conta inativa: eliminados após 3 anos de inatividade',
      legal:
        'Dados necessários a obrigações legais: conservados conforme os prazos legais aplicáveis',
    },
    rights: {
      title: 'Os seus direitos',
      description: 'Em conformidade com o RGPD, tem os seguintes direitos:',
      access: 'Direito de acesso: consultar os seus dados pessoais',
      rectification: 'Direito de retificação: corrigir os seus dados inexatos',
      deletion: 'Direito ao apagamento: eliminar os seus dados (direito ao esquecimento)',
      portability: 'Direito à portabilidade: recuperar os seus dados em formato estruturado',
      opposition: 'Direito de oposição: opor-se ao tratamento dos seus dados',
      limitation: 'Direito à limitação: limitar o tratamento dos seus dados',
      contact:
        'Para exercer os seus direitos, contacte-nos em: contact@axialdata.net. Também pode exportar ou eliminar os seus dados em Definições da conta.',
    },
    security: {
      title: 'Segurança dos dados',
      description:
        'Implementamos medidas técnicas e organizacionais adequadas para proteger os seus dados contra acesso não autorizado, perda, destruição ou alteração. Os dados são armazenados em servidores seguros e as comunicações são encriptadas.',
    },
    cookies: {
      title: 'Cookies e rastreadores',
      description:
        'A nossa aplicação utiliza cookies essenciais para o funcionamento do serviço. Para mais informações, consulte a nossa política de cookies.',
      link: 'Política de cookies',
    },
    contact: {
      title: 'Contacto',
      description: 'Para qualquer questão sobre esta política ou os seus dados pessoais:',
      email: 'contact@axialdata.net',
    },
  },
  cookies: {
    title: 'Política de cookies',
    intro: {
      title: 'Introdução',
      description:
        'Esta página informa-o sobre a utilização de cookies e tecnologias similares no PlayItNow.',
    },
    essential: {
      title: 'Cookies essenciais',
      description:
        'Os seguintes cookies são estritamente necessários ao funcionamento do serviço e não requerem consentimento prévio:',
      accessToken: {
        title: 'access_token',
        description:
          'Cookie de autenticação que mantém a sua sessão ativa. Este cookie é httpOnly (inacessível via JavaScript) e seguro.',
        duration: 'Duração: 15 minutos',
      },
      refreshToken: {
        title: 'refresh_token',
        description:
          'Cookie que renova automaticamente a sua sessão. Este cookie é httpOnly e seguro.',
        duration: 'Duração: 7 dias',
      },
      csrfToken: {
        title: 'csrf_token',
        description:
          'Cookie de proteção contra ataques CSRF (Cross-Site Request Forgery). Este cookie é acessível via JavaScript para validação no cliente.',
        duration: 'Duração: 7 dias',
      },
    },
    localStorage: {
      title: 'Armazenamento local (localStorage)',
      description:
        'Também utilizamos o armazenamento local do seu navegador para memorizar as suas preferências:',
      theme: 'Tema de exibição (modo claro/escuro)',
      lang: 'Idioma preferido',
      firstname: 'Primeiro nome (para exibição durante os votos)',
      fingerprint: 'Impressão digital do navegador (anti-fraude)',
    },
    analytics: {
      title: 'Medição de audiência (Rybbit)',
      description:
        'Quando a medição de audiência está ativada (produção), um script Rybbit, alojado nos nossos próprios servidores (analytics.axialdata.app), envia dados mínimos (páginas vistas, proveniência) para analisar a utilização do site, para uso estritamente interno. Sem publicidade; nenhum dado é vendido nem cedido a terceiros. Este tratamento baseia-se no nosso interesse legítimo. O Rybbit pode utilizar um identificador técnico (cookie ou armazenamento local) para deduplicar visitas. Pode bloquear scripts de terceiros no seu navegador para desativar este acompanhamento.',
    },
    management: {
      title: 'Gestão de cookies',
      description:
        'Pode gerir os cookies através das definições do seu navegador. Note que desativar os cookies essenciais impedirá o correto funcionamento da aplicação.',
    },
  },
  terms: {
    title: 'Condições Gerais de Utilização',
    lastUpdated: 'Última atualização: outubro de 2025',
    intro: {
      title: 'Artigo 1 - Objeto',
      description:
        'As presentes Condições Gerais de Utilização (CGU) regem a utilização do serviço PlayItNow, uma plataforma SaaS que permite aos grupos de música oferecer uma experiência interativa ao seu público em concertos. Estas CGU aplicam-se tanto aos grupos (clientes pagantes) como aos espetadores (utilizadores gratuitos).',
    },
    service: {
      title: 'Artigo 2 - Descrição do serviço',
      description:
        'O PlayItNow é uma aplicação web que permite aos grupos de música criar eventos, gerir uma biblioteca de músicas e permitir ao público votar nas músicas que desejam ouvir. O serviço é pago para os grupos e gratuito para os espetadores.',
    },
    forBands: {
      title: 'Artigo 3 - Condições específicas para grupos',
      subtitle:
        'As seguintes condições aplicam-se apenas aos grupos que utilizam o serviço como clientes pagantes:',
      registration: {
        title: '3.1 - Registo e conta',
        description:
          'Para utilizar o serviço como grupo, deve criar uma conta fornecendo informações exatas e atualizadas. É responsável pela confidencialidade das suas credenciais e por todas as atividades realizadas a partir da sua conta.',
      },
      subscription: {
        title: '3.2 - Assinaturas e tarifas',
        description:
          'O acesso ao serviço para os grupos está sujeito a uma assinatura paga. Os preços, planos e condições de assinatura estão disponíveis na plataforma. As assinaturas são renovadas automaticamente exceto se cancelar.',
      },
      payment: {
        title: '3.3 - Pagamento',
        description:
          'Os pagamentos são efetuados através de um prestador de pagamento seguro. Em caso de incumprimento de pagamento, o acesso ao serviço pode ser suspenso. Nenhum reembolso é devido em caso de rescisão antecipada, exceto quando exigido por lei.',
      },
      obligations: {
        title: '3.4 - Obrigações',
        customer: {
          title: '3.4.1 - Obrigações do cliente',
          accuracy: 'Fornecer informações exatas e atualizadas',
          security: 'Manter a confidencialidade das suas credenciais',
          compliance: 'Cumprir as leis e regulamentos aplicáveis',
          prohibited: 'Não utilizar o serviço para fins ilegais ou fraudulentos',
        },
        provider: {
          title: '3.4.2 - Obrigações do prestador',
          availability: 'Garantir a disponibilidade do serviço na medida do possível',
          support: 'Prestar suporte técnico dentro dos limites do serviço',
          security: 'Implementar medidas de segurança adequadas',
        },
      },
      intellectualProperty: {
        title: '3.5 - Propriedade intelectual',
        description:
          'Todos os elementos do serviço PlayItNow (código, design, marcas, etc.) são propriedade exclusiva da axialdata. A utilização do serviço não confere quaisquer direitos de propriedade sobre estes elementos.',
      },
      termination: {
        title: '3.6 - Rescisão',
        description:
          'Pode cancelar a sua assinatura a qualquer momento a partir da sua área de cliente. A axialdata reserva-se o direito de suspender ou rescindir qualquer conta em caso de incumprimento destas CGU.',
      },
      jurisdiction: {
        title: '3.7 - Lei aplicável e jurisdição',
        description:
          'As presentes CGU são regidas pela lei francesa. Em caso de litígio, os tribunais franceses têm jurisdição exclusiva.',
      },
    },
    forSpectators: {
      title: 'Artigo 4 - Condições específicas para espetadores',
      subtitle:
        'As seguintes condições aplicam-se apenas aos espetadores que utilizam o serviço gratuitamente:',
      voting: {
        title: '4.1 - Sistema de votação',
        description: 'Ao participar num evento, pode:',
        rules: {
          one: 'Votar numa ou mais músicas conforme as regras definidas pelo grupo',
          fraud: 'Respeitar os limites de votação para evitar fraudes',
          respect: 'Utilizar o serviço de forma respeitosa e em conformidade com o seu objetivo',
        },
      },
      account: {
        title: '4.2 - Conta de utilizador',
        description:
          'A criação de conta é opcional. Pode participar anonimamente fornecendo apenas um primeiro nome. Se criar uma conta, é responsável pela confidencialidade das suas credenciais.',
      },
      conduct: {
        title: '4.3 - Regras de conduta',
        description: 'É estritamente proibido:',
        prohibited: {
          fraud: 'Tentar fraudar o sistema de votação',
          abuse: 'Utilizar o serviço de forma abusiva ou maliciosa',
          illegal: 'Utilizar o serviço para fins ilegais',
        },
      },
      privacy: {
        title: '4.4 - Dados pessoais',
        description:
          'O tratamento dos seus dados pessoais é regido pela nossa política de privacidade. Ao utilizar o serviço, aceita esta política.',
        link: 'Consulte a nossa política de privacidade',
      },
    },
    liability: {
      title: 'Artigo 5 - Responsabilidade',
      description:
        'A axialdata não pode ser responsabilizada por danos diretos ou indiretos decorrentes da utilização ou impossibilidade de utilização do serviço. Para os grupos, a responsabilidade está limitada ao montante dos valores pagos pela assinatura. Para os espetadores, o serviço é prestado "tal como está" sem qualquer garantia.',
    },
    modifications: {
      title: 'Artigo 6 - Modificações',
      description:
        'A axialdata reserva-se o direito de modificar as presentes CGU a qualquer momento. As modificações entram em vigor após publicação. A sua utilização continuada do serviço constitui aceitação das novas condições.',
    },
    contact: {
      title: 'Artigo 7 - Contacto',
      description: 'Para qualquer questão sobre as presentes CGU:',
      email: 'contact@axialdata.net',
    },
  },
  cookieBanner: {
    message:
      'Este site utiliza cookies essenciais e medição de audiência (anónima, uso estritamente interno). Ao continuar a navegar, aceita a sua utilização.',
    learnMore: 'Saber mais sobre cookies',
    accept: 'Aceito',
  },
  footer: {
    legal: 'Nota legal',
    privacy: 'Privacidade',
    cookies: 'Cookies',
    terms: 'CGU',
  },
  errors: {
    EVENT_NOT_AVAILABLE_YET:
      'Este evento ainda não está disponível. Volte na data e hora previstas para aceder à votação.',
    networkError:
      'Não foi possível contactar o servidor. Verifique a sua ligação ou tente mais tarde.',
    unexpectedError: 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
    validationError: 'Dados inválidos. Verifique o formulário.',
    badRequest: 'Pedido inválido.',
    unauthorized: 'Autenticação necessária.',
    forbidden: 'Acesso negado.',
    notFound: 'Recurso não encontrado.',
    invalidJsonBody: 'Formato de dados inválido.',
    invalidCredentials: 'Credenciais inválidas.',
    emailAlreadyRegistered: 'Este endereço de email já está registado.',
    notAuthenticated: 'Tem de iniciar sessão.',
    tokenRequired: 'Ligação inválida ou expirada.',
    ONE_SHOW_DATE_OUT_OF_RANGE:
      'A data do evento ONE_SHOW deve estar entre a data de compra e +30 dias',
  },
  common: {
    copyright: 'Todos os direitos reservados',
    year: new Date().getFullYear().toString(),
    company: 'axialdata',
    required: 'Obrigatório',
    back: 'Voltar',
    goHome: 'Voltar ao início',
    close: 'Fechar',
    cancel: 'Cancelar',
    selectLanguage: 'Selecionar idioma',
    skipToContent: 'Ir para o conteúdo principal',
    activateDarkMode: 'Ativar modo escuro',
    activateLightMode: 'Ativar modo claro',
    loading: 'A carregar...',
    processing: 'A processar...',
    logoUrlExpiringModalTitle: 'O URL da imagem pode expirar',
    logoUrlExpiringModalMessage:
      'Este URL aponta para um anfitrião (ex.: Facebook) cujos links de imagens podem tornar-se inválidos com o tempo. A imagem pode deixar de ser exibida mais tarde. Pode guardar este URL se desejar.',
    ok: 'OK',
  },
  pwa: {
    install: {
      button: 'Instalar a aplicação',
      installButton: 'Instalar',
      promptDescription: 'Instale o PlayItNow no seu dispositivo para uma melhor experiência',
      waiting: 'À espera da autorização de instalação...',
      iosButton: 'Instalar no iOS',
      iosTitle: 'Instalar o PlayItNow no seu iPhone/iPad',
      iosStep1: '1. Toque no botão de partilha na parte inferior do ecrã',
      iosStep2: '2. Deslize e selecione "Adicionar ao ecrã inicial"',
      iosStep3: '3. Toque em "Adicionar" para instalar a aplicação',
    },
  },
  forgotPassword: {
    title: 'Palavra-passe esquecida',
    subtitle: 'Introduza o seu email para receber uma ligação de redefinição',
    emailLabel: 'Morada de email',
    emailPlaceholder: 'seu@email.com',
    submitButton: 'Enviar ligação de redefinição',
    submitting: 'A enviar...',
    successMessage: 'Se existir uma conta com este email, foi enviada uma ligação de redefinição.',
    backToLogin: 'Voltar ao início de sessão',
    errorGeneric: 'Ocorreu um erro',
  },
  resetPassword: {
    title: 'Redefinir palavra-passe',
    subtitle: 'Introduza a sua nova palavra-passe',
    passwordLabel: 'Nova palavra-passe',
    passwordPlaceholder: '••••••••',
    confirmPasswordLabel: 'Confirmar palavra-passe',
    confirmPasswordPlaceholder: '••••••••',
    submitButton: 'Redefinir palavra-passe',
    submitting: 'A redefinir...',
    successMessage: 'A sua palavra-passe foi redefinida com sucesso. Pode agora iniciar sessão.',
    passwordsDoNotMatch: 'As palavras-passe não coincidem',
    backToLogin: 'Voltar ao início de sessão',
    errorGeneric: 'Ocorreu um erro durante a redefinição',
    invalidToken: 'A ligação de redefinição é inválida ou expirou',
  },
  confirmEmail: {
    title: 'Confirme o seu endereço de email',
    setPasswordTitle: 'Definir a sua palavra-passe',
    setPasswordSubtitle: 'Escolha uma palavra-passe para concluir o seu registo.',
    passwordLabel: 'Palavra-passe',
    confirmPasswordLabel: 'Confirmar palavra-passe',
    submitButton: 'Ativar a minha conta',
    confirming: 'A confirmar…',
    successFan: 'Conta ativada. A redirecionar…',
    successBand: 'Conta criada. A redirecionar…',
    alreadyCompleted: 'Registo já concluído ou ligação expirada. Inicie sessão.',
    goToLogin: 'Ir para iniciar sessão',
    invalidToken: 'Ligação inválida ou expirada. Registe-se novamente ou solicite um novo email.',
    missingToken: 'Falta a ligação de confirmação.',
    errorGeneric: 'Ocorreu um erro.',
    backToRegister: 'Voltar ao registo',
  },
  admin: {
    nav: {
      dashboard: 'Painel',
      events: 'Eventos',
      songs: 'Músicas',
      venues: 'Locais',
      members: 'Membros',
      settings: 'Definições',
      userSettings: 'A minha conta',
      logout: 'Terminar sessão',
    },
    dashboard: {
      welcome: 'Bem-vindo',
      bandName: 'Grupo',
      superadminMode: 'Modo Super Administrador',
      totalEvents: 'Total de eventos',
      activeEvents: 'Eventos ativos',
      upcomingEvents: 'Próximos eventos',
      quickActions: 'Ações rápidas',
      createEvent: 'Criar evento',
      manageVenues: 'Gerir locais',
      recentEvents: 'Eventos recentes',
      viewAll: 'Ver tudo',
      noEvents: 'Ainda sem eventos',
      createFirstEvent: 'Crie o seu primeiro evento',
      noVenue: 'Sem local',
      errorLoad: 'Erro ao carregar os dados',
      status: {
        pending: 'Pendente',
        active: 'Ativo',
        completed: 'Terminado',
      },
    },
    planBadge: {
      tooltip: 'Plano atual — Clique para gerir a sua assinatura',
      ariaLabel: 'Ver e gerir a sua assinatura',
    },
    oneShowAlert: {
      title: 'Validade do evento OneShow',
      daysRemaining: '{{days}} dia(s) restante(s)',
      daysShort: '{{days}}d',
      daysRemainingMessage:
        'Restam-lhe {{days}} dia(s) para utilizar este evento em modo ilimitado.',
      urgentTitle: 'Expiração iminente',
      expired: 'Evento OneShow expirado',
      expiredShort: 'Expirado',
      expiredMessage:
        'Este evento atingiu o fim do seu período de validade. Mude para ProGig para eventos ilimitados.',
      upgradeCta: 'Ver planos',
    },
    subscription: {
      plan: {
        FREE: 'Free',
        PRO_GIG: 'ProGig',
        LIVE_TOUR: 'LiveTour',
        ONE_SHOW: 'OneShow',
      },
      title: 'Assinatura',
      subtitle: 'Gerir o plano do seu grupo e limites de utilização',
      currentPlan: 'Plano atual',
      currentPlanFree: 'Gratuito (FREE)',
      currentPlanProGig: 'ProGig',
      currentPlanLiveTour: 'LiveTour',
      freeDescription: 'Perfeito para descobrir e experimentar o serviço.',
      proGigDescription: 'Plano para grupos com vários concertos por mês.',
      liveTourDescription: 'Plano para digressões intensivas e utilização ilimitada.',
      chooseProGig: 'Mudar para ProGig',
      chooseLiveTour: 'Mudar para LiveTour',
      loading: 'A carregar a sua assinatura...',
      errorLoad: 'Erro ao carregar a sua assinatura.',
      errorCheckout:
        'Erro ao criar a sessão de pagamento Stripe. Por favor, tente novamente dentro de momentos.',
      successTitle: 'Pagamento realizado com sucesso',
      successMessage: 'O seu pagamento foi processado. A sua assinatura será atualizada em breve.',
      successRedirect: 'Será redirecionado para o seu painel em breve.',
      monthlyQuota: 'Quota mensal',
      freeQuota: 'Quota gratuita',
      eventsUsed: '{{current}} / {{limit}} eventos',
      billingPeriod: 'Período: {{start}} - {{end}}',
      quotaReached: 'Quota mensal atingida',
      quotaReachedMessage:
        'Atingiu o limite de eventos para este período. A quota será reposta no final do período de faturação.',
      quotaWarning: 'Quota mensal quase atingida',
      quotaWarningMessage: 'Restam-lhe {{remaining}} evento(s) para este período.',
      quotaInfo: 'Restam-lhe {{remaining}} evento(s) para este período.',
      upgradePlan: 'Melhorar plano',
      upgradeToUnlimited: 'Passar para ilimitado',
      upgradeSingleEventConfirm: 'Está prestes a passar o evento "{{eventName}}" para ilimitado.',
      singleEventDescription:
        'Trata-se de um pagamento único para votos ilimitados neste evento específico.',
      oneShowValidity: 'Válido {{days}} dias a partir da compra.',
      oneShowNonRefundable:
        'Pagamento não reembolsável: uma vez efetuado, o pagamento não pode ser cancelado ou reembolsado.',
      multipleProGigSuggestion: 'Vários eventos? O plano ProGig poderá ser mais vantajoso.',
      comparePlans: 'Comparar planos →',
      upgradeToUnlimitedNow: 'Passar para ilimitado agora',
      checkoutError: 'Erro ao criar a sessão de pagamento. Por favor, tente novamente.',
      oneShowPrice: 'Preço',
      oneShowPaymentType: 'Pagamento único',
      oneShowBenefitsTitle: 'O que obtém:',
      oneShowBenefitVotes: 'Votos ilimitados para este evento',
      oneShowBenefitTime: 'Sem limite de tempo de ativação',
      chooseOption: 'Escolher uma opção',
      convertEvent: 'Converter um evento',
      createEvent: 'Criar evento',
      selectFreeEvent: 'Selecione um evento gratuito para converter:',
      convertThisEvent: 'Converter este evento',
      noFreeEventsToConvert: 'Sem eventos gratuitos para converter. Crie primeiro um evento.',
      createDescription: 'Crie um novo evento com o plano Evento único.',
      createNewOneShot: 'Criar evento único',
      createOneShotEventTitle: 'Criar evento único',
      proceedToPayment: 'Proceder ao pagamento',
      oneShowDescription: 'Pagamento único para um evento ilimitado.',
      configureOneShot: 'Configurar',
      convertEventFromUrl: 'O evento "{{name}}" será convertido em evento único.',
      priceFree: 'Gratuito',
      priceOneTime: '{{price}}€ (pagamento único)',
      pricePerMonth: '{{price}}€ / mês',
      currentPlanBadge: 'Plano atual',
      selectPlan: 'Escolher',
      planFree: 'Gratuito',
      featureMaxEvents: 'Eventos máximos',
      featureMaxVotes: 'Votos por evento',
      featureActiveTime: 'Tempo ativo cumulativo',
      featureEventsPerMonth: 'Eventos por mês',
      featureOneEvent: '1 evento (único)',
      featureValidity: 'Validade',
      validityDays: '{{days}} dias',
      unlimited: 'Ilimitado',
      events: 'eventos',
      votes: 'votos',
      minutes: 'min',
      planNote: {
        FREE: '5 eventos máx. (excl. OneShow). 8 votos por evento. 40 min de ativação cumulativa.',
        ONE_SHOW: 'Pagamento único. Um evento ilimitado (votos ilimitados, sem limite de tempo).',
        PRO_GIG: '3 eventos por mês (período deslizante conforme faturação Stripe).',
        LIVE_TOUR: 'Eventos ilimitados. Ideal para digressões.',
      },
      cancelSubscriptionButton: 'Cancelar assinatura',
      cancelSubscriptionConfirmTitle: 'Cancelar assinatura',
      cancelSubscriptionConfirmMessage:
        'Sem reembolso. A sua assinatura permanece ativa até {{date}} (fim do período já pago), depois passará para o plano gratuito. Continuar?',
      cancelSubscriptionSuccess: 'Assinatura cancelada. Mantém o acesso até {{date}}.',
      cancelSubscriptionError: 'Erro ao cancelar a assinatura.',
      accessUntil: 'Acesso até {{date}}',
      cancellationScheduled: 'Cancelação agendada',
      cancelling: 'A cancelar...',
    },
    events: {
      title: 'Eventos',
      subtitle: 'Gerir os seus concertos e eventos',
      eventsList: 'Lista de eventos',
      upcomingEvents: 'Próximos eventos',
      pastEvents: 'Eventos passados',
      noEvents: 'Ainda sem eventos',
      addEvent: 'Criar evento',
      add: 'Criar',
      adding: 'A criar...',
      edit: 'Editar',
      editing: 'A editar...',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      confirmDeleteTitle: 'Eliminar evento',
      confirmDelete: 'Tem a certeza que deseja eliminar o evento "{{name}}"?',
      name: 'Nome do evento',
      namePlaceholder: 'Ex: Concerto no Zenith',
      venue: 'Local',
      selectVenue: 'Selecionar local',
      date: 'Data',
      time: 'Hora',
      oneShowDateRestriction: 'Data bloqueada: entre a compra e +{{days}} dias',
      maxVotesPerUser: 'Votos máximos por utilizador',
      maxVotes: 'Votos máx.',
      tiebreaker: 'Desempate',
      tiebreakerChronological: 'Cronológico (primeiro votado)',
      tiebreakerRandom: 'Aleatório',
      tiebreakerManual: 'Manual (escolha do grupo)',
      showRanking: 'Mostrar ranking',
      showRankingToPublic: 'Mostrar ranking ao público',
      blindVote: 'Voto secreto',
      status: {
        pending: 'Pendente',
        active: 'Ativo',
        completed: 'Terminado',
      },
      planBadge: {
        subscription: 'Assinatura (ilimitado)',
        oneShow: 'OneShow (evento ilimitado)',
      },
      addSuccess: 'Evento criado com sucesso',
      addError: 'Erro ao criar o evento',
      updateSuccess: 'Evento atualizado com sucesso',
      updateError: 'Erro ao atualizar o evento',
      deleteSuccess: 'Evento eliminado com sucesso',
      deleteError: 'Erro ao eliminar o evento',
      errorLoad: 'Erro ao carregar os eventos',
      noVenues: 'Deve criar pelo menos um local antes de criar um evento',
      qrCodeTitle: 'Código QR gerado',
      qrCodeDescription: 'Utilize este código para permitir aos espetadores votar',
      copyQRCode: 'Copiar código QR',
      qrCodeCopied: 'Código QR copiado para a área de transferência',
      showQRCode: 'Mostrar código QR',
      qrCodePrint: 'Imprimir',
      qrCodeShare: 'Partilhar',
      qrCodeDownload: 'Transferir',
      qrCodeUrl: 'URL do evento',
      qrCodeShareText: 'Junte-se a mim para votar nas músicas de {{eventName}}!',
      qrCodePrintTitle: 'Código QR - PlayItNow',
      qrCodePrintInstructions:
        'Digitalize este código QR para aceder ao evento e votar nas suas músicas preferidas. As músicas vencedoras serão tocadas ao vivo!',
      delete: 'Eliminar',
      activate: 'Ativar',
      deactivate: 'Desativar',
      complete: 'Terminar',
      reactivate: 'Reativar',
      activateSuccess: 'Evento ativado com sucesso',
      activateError: 'Erro ao ativar o evento',
      deactivateSuccess: 'Evento desativado com sucesso',
      deactivateError: 'Erro ao desativar o evento',
      completeSuccess: 'Evento terminado com sucesso',
      completeError: 'Erro ao terminar o evento',
      showRankingBtn: 'Mostrar ranking aos espetadores',
      hideRankingBtn: 'Ocultar ranking dos espetadores',
      rankingHidden: 'Ranking oculto aos espetadores',
      rankingVisible: 'Ranking visível aos espetadores',
      toggleBlindVoteError: 'Erro ao alterar a visibilidade do ranking',
      live: {
        title: 'Painel em direto',
        loading: 'A carregar...',
        errorLoad: 'Erro ao carregar os dados',
        errorToggle: 'Erro ao alterar a visibilidade',
        errorMarkPlayed: 'Erro ao marcar a música',
        eventNotFound: 'Evento não encontrado',
        backToEvents: 'Voltar aos eventos',
        totalVotes: 'Total de votos',
        uniqueVoters: 'Votantes únicos',
        songsPlayed: 'Músicas tocadas',
        noVotesYet: 'Ainda sem votos',
        noVotes: 'Ainda sem votos',
        rankingHidden: 'Ranking oculto',
        rankingVisible: 'Ranking visível',
        markPlayed: 'Marcar como tocada',
        unmarkPlayed: 'Anular a marcação',
        autoRefresh: 'Atualização automática',
        openLive: 'Abrir em direto',
      },
      songs: {
        title: 'Músicas do evento',
        subtitle: 'Gerir as músicas disponíveis para votação',
        addSong: 'Adicionar música',
        searchExisting: 'Procurar música existente',
        searchPlaceholder: 'Procurar por título ou artista...',
        noResults: 'Nenhuma música encontrada',
        or: 'OU',
        songTitle: 'Título',
        titlePlaceholder: 'Ex: Bohemian Rhapsody',
        artist: 'Artista',
        artistPlaceholder: 'Ex: Queen',
        duration: 'Duração',
        durationPlaceholder: 'Ex: 5:55',
        year: 'Ano',
        yearPlaceholder: 'Ex: 2020',
        add: 'Adicionar',
        adding: 'A adicionar...',
        remove: 'Remover',
        noSongs: 'Nenhuma música para este evento',
        addSuccess: 'Música adicionada com sucesso',
        addError: 'Erro ao adicionar a música',
        createSuccess: 'Música criada e adicionada com sucesso',
        createError: 'Erro ao criar a música',
        removeSuccess: 'Música removida com sucesso',
        removeError: 'Erro ao remover a música',
        errorLoad: 'Erro ao carregar as músicas',
        copyFromEvent: 'Copiar de outro evento',
        copyModal: {
          title: 'Copiar lista de músicas',
          description: 'Selecione um evento para copiar a sua lista de músicas para este evento.',
          noEvents: 'Nenhum outro evento disponível',
        },
        copySuccess: 'Músicas copiadas com sucesso',
        copySuccessCount: 'música(s) adicionada(s)',
        copySkipped: 'já presente(s)',
        copyNoSongs: 'O evento selecionado não contém músicas',
        copyAllAlreadyAdded: 'Todas as músicas deste evento já estão presentes',
        copyError: 'Erro ao copiar as músicas',
      },
    },
    songs: {
      title: 'Biblioteca de músicas',
      subtitle: 'Gerir o seu reportório de músicas',
      songsList: 'Lista de músicas',
      noSongs: 'Ainda sem músicas',
      addSong: 'Adicionar música',
      add: 'Adicionar',
      adding: 'A adicionar...',
      edit: 'Editar',
      editing: 'A editar...',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      confirmDeleteTitle: 'Eliminar música',
      confirmDelete: 'Tem a certeza que deseja eliminar "{{title}}" de {{artist}}?',
      songTitle: 'Título',
      titlePlaceholder: 'Ex: Bohemian Rhapsody',
      artist: 'Artista',
      artistPlaceholder: 'Ex: Queen',
      duration: 'Duração',
      durationPlaceholder: 'Ex: 5:55',
      durationFormat: 'Formato: MM:SS (ex: 3:45)',
      year: 'Ano',
      yearPlaceholder: 'Ex: 2020',
      addSuccess: 'Música adicionada com sucesso',
      addError: 'Erro ao adicionar a música',
      updateSuccess: 'Música atualizada com sucesso',
      updateError: 'Erro ao atualizar a música',
      deleteSuccess: 'Música eliminada com sucesso',
      deleteError: 'Erro ao eliminar a música',
      errorLoad: 'Erro ao carregar as músicas',
      delete: 'Eliminar',
    },
    settings: {
      title: 'Definições do grupo',
      subtitle: 'Gerir as informações do seu grupo',
      bandName: 'Nome do grupo',
      bandNamePlaceholder: 'Nome do seu grupo',
      logoUrl: 'URL do logótipo',
      logoUrlPlaceholder: 'https://example.com/logo.png',
      logoPreview: 'Pré-visualização do logótipo',
      save: 'Guardar',
      saving: 'A guardar...',
      successMessage: 'Definições guardadas com sucesso',
      errorLoad: 'Erro ao carregar as definições',
      errorSave: 'Erro ao guardar as definições',
    },
    userSettings: {
      title: 'A minha conta',
      account: 'Informações da conta',
      email: 'Email',
      username: 'Nome de utilizador',
      firstName: 'Primeiro nome',
      lastName: 'Apelido',
      save: 'Guardar alterações',
      saving: 'A guardar...',
      success: 'Definições da conta atualizadas com sucesso',
      error: 'Erro ao atualizar a conta',
      password: {
        title: 'Alterar palavra-passe',
        currentPassword: 'Palavra-passe atual',
        currentPasswordPlaceholder: '••••••••',
        newPassword: 'Nova palavra-passe',
        newPasswordPlaceholder: '••••••••',
        confirmPassword: 'Confirmar nova palavra-passe',
        confirmPasswordPlaceholder: '••••••••',
        change: 'Alterar palavra-passe',
        changing: 'A alterar...',
        success: 'Palavra-passe alterada com sucesso. Por favor, inicie sessão novamente.',
        error: 'Erro ao alterar a palavra-passe',
        mismatch: 'As palavras-passe não coincidem',
        incorrect: 'A palavra-passe atual está incorreta',
      },
      deleteAccount: {
        title: 'Eliminar conta',
        description:
          'A eliminação da sua conta é irreversível. Todos os seus dados serão perdidos.',
        button: 'Eliminar a minha conta',
        confirmTitle: 'Confirmar eliminação',
        confirmMessage: 'Tem a certeza que deseja eliminar a sua conta? Esta ação é irreversível.',
        confirmButton: 'Sim, eliminar',
        cancelButton: 'Cancelar',
        confirming: 'A eliminar...',
        error: 'Erro ao eliminar a conta',
      },
    },
    members: {
      title: 'Membros do grupo',
      subtitle: 'Gerir os membros do seu grupo',
      membersList: 'Lista de membros',
      noMembers: 'Ainda sem membros',
      inviteMember: 'Convidar membro',
      invite: 'Convidar',
      inviting: 'A convidar...',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      confirmRemoveTitle: 'Remover membro',
      confirmToggleOwnerTitle: 'Alterar estatuto de proprietário',
      email: 'Email',
      emailPlaceholder: 'membro@example.com',
      password: 'Palavra-passe',
      passwordPlaceholder: 'Mínimo 8 caracteres',
      firstName: 'Primeiro nome',
      firstNamePlaceholder: 'Primeiro nome (opcional)',
      lastName: 'Apelido',
      lastNamePlaceholder: 'Apelido (opcional)',
      owner: 'Proprietário',
      invitedBy: 'Convidado por',
      remove: 'Remover',
      confirmRemove: 'Tem a certeza que deseja remover {{email}} do grupo?',
      inviteSuccess: 'Membro convidado com sucesso',
      inviteError: 'Erro ao convidar o membro',
      removeSuccess: 'Membro removido com sucesso',
      removeError: 'Erro ao remover o membro',
      errorLoad: 'Erro ao carregar os membros',
      promote: 'Promover a proprietário',
      demote: 'Rebaixar',
      confirmToggleOwner: 'Tem a certeza que deseja {{action}} este membro?',
      promoteSuccess: 'Membro promovido a proprietário com sucesso',
      demoteSuccess: 'Membro rebaixado com sucesso',
      toggleOwnerError: 'Erro ao alterar o estatuto do membro',
    },
    venues: {
      title: 'Locais de concerto',
      subtitle: 'Gerir os locais onde atua',
      venuesList: 'Lista de locais',
      noVenues: 'Ainda sem locais',
      addVenue: 'Adicionar local',
      add: 'Adicionar',
      adding: 'A adicionar...',
      edit: 'Editar',
      editing: 'A editar...',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      confirmDeleteTitle: 'Eliminar local',
      confirmDelete: 'Tem a certeza que deseja eliminar o local "{{name}}"?',
      name: 'Nome do local',
      namePlaceholder: 'Ex: O Zenith',
      address: 'Morada',
      addressPlaceholder: 'Ex: 211 Avenue Jean Jaurès',
      city: 'Cidade',
      cityPlaceholder: 'Ex: Paris',
      country: 'País',
      countryPlaceholder: 'Ex: França',
      googleMapsUrl: 'Ligação Google Maps',
      googleMapsUrlPlaceholder: 'Ex: https://maps.google.com/...',
      generateMapsUrl: 'Gerar ligação Google Maps',
      generateMapsUrlError:
        'Introduza pelo menos o nome do local ou a cidade para gerar a ligação.',
      viewOnGoogleMaps: 'Ver no Google Maps',
      addSuccess: 'Local adicionado com sucesso',
      addError: 'Erro ao adicionar o local',
      updateSuccess: 'Local atualizado com sucesso',
      updateError: 'Erro ao atualizar o local',
      deleteSuccess: 'Local eliminado com sucesso',
      deleteError: 'Erro ao eliminar o local',
      errorLoad: 'Erro ao carregar os locais',
    },
  },
  notFound: {
    title: 'Página não encontrada',
    subtitle: 'Ups! Esta página não existe',
    description: 'A página que procura pode ter sido movida ou eliminada.',
    quickLinks: 'Ligações rápidas',
    goHome: 'Ir para o início',
    goToLogin: 'Ir ao início de sessão',
    helpText: 'Se acha que isto é um erro, por favor contacte o suporte.',
  },
}
